import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "list-actions-admin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: !_vm.isDialogHasRequiredData,
      rounded: true
    },
    on: {
      click: function click(_) {
        _vm.importerIdEdited = 0;
        _vm.importerDialogShown = true;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New importer ")], 1)], 1), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": -1,
      loading: _vm.isLoadingData,
      "loading-text": "Loading... Please wait",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.editImporter
    },
    scopedSlots: _vm._u([{
      key: "item.locations",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.nb_countries_available === 1 ? item.countriesAvailable[0].country.printable_name : item.nb_countries_available + " countries") + " "), item.nb_states_available > 0 ? _c("span", [_vm._v(" : " + _vm._s(item.nb_states_available + " state" + (item.nb_states_available > 1 ? "s" : "")) + " ")]) : _vm._e(), _c("span", {
          staticClass: "text-smaller ml-1"
        }, [_vm._v("(Priority : " + _vm._s(item.priority) + ")")])])];
      }
    }, {
      key: "item.deleted",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.deleted ? _c("div", {
          staticClass: "badge danger"
        }, [_vm._v("Deactivated")]) : _c("div", {
          staticClass: "badge success"
        }, [_vm._v("Activated")])];
      }
    }, {
      key: "item.isPreventingPayment",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.isPreventingPayment ? _c("div", {
          staticClass: "badge neutral"
        }, [_vm._v("C&M does not collect")]) : _c("div", {
          staticClass: "badge info"
        }, [_vm._v("C&M collects")])];
      }
    }, {
      key: "item.isInternalImporter",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [!item.isInternalImporter ? _c("div", {
          staticClass: "badge neutral"
        }, [_vm._v(" Platform does NOT generate importer accountancy files ")]) : _c("div", {
          staticClass: "badge info"
        }, [_vm._v("Platform generates importer accountancy files")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [_vm.isDialogHasRequiredData ? _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.editImporter(item);
            }
          }
        }, [_vm._v("Edit")]) : _vm._e(), !item.deleted ? _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.deleteImporter(item);
            }
          }
        }, [_vm._v("Deactivate")]) : _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.activateImporter(item);
            }
          }
        }, [_vm._v("Activate")])])])];
      }
    }], null, true)
  })], 1), _vm.importerDialogShown ? _c("ImporterDialog", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      listCountriesRef: _vm.listCountries,
      listStatesRef: _vm.listStates,
      importerId: _vm.importerIdEdited,
      listChange: _vm.fetchImporters,
      close: function close(_) {
        _vm.importerDialogShown = false;
      }
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };